const jossStick = () => {
  try {
    let joss_stick = document.querySelector('.customkey_joss_stick_option_radio_お線香を注文していない');
    let joss_stick2 = document.querySelector('.customkey_joss_stick_option_radio_葬儀場で受け取る');
    let joss_stick_option = document.querySelector('.customkey_joss_stick_option_radio_送り先へ直接郵送する');
   
    //let joss_stick_option_div = document.querySelectorAll('.customkey_joss_stick_option');
    let joss_stick_name1 = document.querySelectorAll('.customkey_joss_stick_name_1');
    let joss_stick_name2 = document.querySelectorAll('.customkey_joss_stick_name_2');
    let joss_stick_address = document.querySelectorAll('.customkey_joss_stick_address');
    let joss_stick_phone = document.querySelectorAll('.customkey_joss_stick_phone');
    let joss_stick_receive_address = document.querySelectorAll('.customkey_receive_address');
  
    /*if(joss_stick.checked == true) {
      for(let i = 0; i < joss_stick_option_div.length; i++) {
        joss_stick_option_div[i].style.display = 'flex';
      }
    }
    else {
      for(let i = 0; i < joss_stick_option_div.length; i++) {
        joss_stick_option_div[i].style.display = 'none';
      }
    }*/
    
    /*let newElem = document.createElement('DIV');
    newElem.classList.add('cart__customer-label');
    newElem.classList.add('full');
    newElem.classList.add('cart__customer-label--mTop');
    newElem.innerHTML = 'お線香を注文した方';
    document.querySelector('.cart-customer-form').querySelector('.cart__customer').insertBefore(newElem, joss_stick_option_div[0]);
    */

    for(let i = 0; i < joss_stick_name1.length; i++) {
      joss_stick_name1[i].querySelector('.cart__customer-label').innerHTML = joss_stick_name1[i].querySelector('.cart__customer-label').innerHTML + '<span class="note">※必須</span>';
    }

    for(let i = 0; i < joss_stick_name2.length; i++) {
      joss_stick_name2[i].querySelector('.cart__customer-label').innerHTML = joss_stick_name2[i].querySelector('.cart__customer-label').innerHTML + '<span class="note">※必須</span>';
    }

    for(let i = 0; i < joss_stick_address.length; i++) {
      joss_stick_address[i].querySelector('.cart__customer-label').innerHTML = joss_stick_address[i].querySelector('.cart__customer-label').innerHTML + '<span class="note">※必須</span>';
    }

    for(let i = 0; i < joss_stick_phone.length; i++) {
      joss_stick_phone[i].querySelector('.cart__customer-label').innerHTML = joss_stick_phone[i].querySelector('.cart__customer-label').innerHTML + '<span class="note">※必須</span>';
    }
    for(let i = 0; i < joss_stick_receive_address.length; i++) {
      joss_stick_receive_address[i].querySelector('.cart__customer-label').innerHTML = joss_stick_receive_address[i].querySelector('.cart__customer-label').innerHTML + '<span class="note">※必須</span>';
    }

    for(let i = 0; i < joss_stick_name1.length; i++) {
      joss_stick_name1[i].style.display = 'none';
      joss_stick_name1[i].querySelector('input').required = false;
    }

    for(let i = 0; i < joss_stick_name1.length; i++) {
      joss_stick_name2[i].style.display = 'none';
      joss_stick_name2[i].querySelector('input').required = false;
    }

    for(let i = 0; i < joss_stick_address.length; i++) {
      let inputs = joss_stick_address[i].querySelectorAll('.required');
      for(let a = 0; a < inputs.length; a++) {
        joss_stick_address[i].style.display = 'none';
        inputs[a].required = false;
      }
    }

    for(let i = 0; i < joss_stick_phone.length; i++) {
      joss_stick_phone[i].style.display = 'none';
      joss_stick_phone[i].querySelector('input').required = false;
    }

    for(let i = 0; i < joss_stick_receive_address.length; i++) {
      joss_stick_receive_address[i].style.display = 'none';
    }

    if(joss_stick2.checked == false && joss_stick_option.checked == false) {
      joss_stick.checked = true;
    }
    

    if(joss_stick_option.checked == true) {
      for(let i = 0; i < joss_stick_name1.length; i++) {
        joss_stick_name1[i].style.display = 'flex';
        joss_stick_name1[i].querySelector('input').required = true;
      }
  
      for(let i = 0; i < joss_stick_name2.length; i++) {
        joss_stick_name2[i].style.display = 'flex';
        joss_stick_name2[i].querySelector('input').required = true;
      }
  
      for(let i = 0; i < joss_stick_address.length; i++) {
        joss_stick_address[i].style.display = 'flex';
        let inputs = joss_stick_address[i].querySelectorAll('.required');
        for(let a = 0; a < inputs.length; a++) {
          inputs[a].required = true;
        }
      }
  
      for(let i = 0; i < joss_stick_phone.length; i++) {
        joss_stick_phone[i].style.display = 'flex';
        joss_stick_phone[i].querySelector('input ').required = true;
      }
    }

    if(joss_stick2.checked == true) {
      for(let i = 0; i < joss_stick_receive_address.length; i++) {
        joss_stick_receive_address[i].style.display = 'flex';
      }
    }
  
  
    /*joss_stick.addEventListener('change', function(){
      if(this.checked == true) {
        for(let i = 0; i < joss_stick_option_div.length; i++) {
          joss_stick_option_div[i].style.display = 'flex';
        }
      }
      else {
        for(let i = 0; i < joss_stick_option_div.length; i++) {
          joss_stick_option_div[i].style.display = 'none';
        }
      }
    });*/
    joss_stick2.addEventListener('change', function(){
      if(this.checked == true) {
        for(let i = 0; i < joss_stick_name1.length; i++) {
          joss_stick_name1[i].style.display = 'none';
          joss_stick_name1[i].querySelector('input').required = false;
          joss_stick_name1[i].querySelector('input').value = '';
        }
    
        for(let i = 0; i < joss_stick_name1.length; i++) {
          joss_stick_name2[i].style.display = 'none';
          joss_stick_name2[i].querySelector('input').required = false;
          joss_stick_name2[i].querySelector('input').value = '';
        }
    
        for(let i = 0; i < joss_stick_address.length; i++) {
          joss_stick_address[i].style.display = 'none';
          let inputs = joss_stick_address[i].querySelectorAll('.required');
          for(let a = 0; a < inputs.length; a++) {
            inputs[a].required = false;
            inputs[a].value = '';
          }
        }
    
        for(let i = 0; i < joss_stick_phone.length; i++) {
          joss_stick_phone[i].style.display = 'none';
          joss_stick_phone[i].querySelector('input').required = false;
          joss_stick_phone[i].querySelector('input').value = '';
        }

        for(let i = 0; i < joss_stick_receive_address.length; i++) {
          joss_stick_receive_address[i].style.display = 'flex';
        }
      }
    });

    joss_stick.addEventListener('change', function(){
      if(this.checked == true) {
        for(let i = 0; i < joss_stick_name1.length; i++) {
          joss_stick_name1[i].style.display = 'none';
          joss_stick_name1[i].querySelector('input').required = false;
          joss_stick_name1[i].querySelector('input').value = '';
        }
    
        for(let i = 0; i < joss_stick_name1.length; i++) {
          joss_stick_name2[i].style.display = 'none';
          joss_stick_name2[i].querySelector('input').required = false;
          joss_stick_name2[i].querySelector('input').value = '';
        }
    
        for(let i = 0; i < joss_stick_address.length; i++) {
          joss_stick_address[i].style.display = 'none';
          let inputs = joss_stick_address[i].querySelectorAll('.required');
          for(let a = 0; a < inputs.length; a++) {
            inputs[a].required = false;
            inputs[a].value = '';
          }
        }
    
        for(let i = 0; i < joss_stick_phone.length; i++) {
          joss_stick_phone[i].style.display = 'none';
          joss_stick_phone[i].querySelector('input').required = false;
          joss_stick_phone[i].querySelector('input').value = '';
        }

        for(let i = 0; i < joss_stick_receive_address.length; i++) {
          joss_stick_receive_address[i].style.display = 'none';
          let addresses = joss_stick_receive_address[i].querySelectorAll('input');

          for(let a = 0; a < addresses.length; a++) {
            addresses[a].checked = false;
          }
        }
      }
    });
    
  
    joss_stick_option.addEventListener('change', function(){
      if(joss_stick_option.checked == true) {
        for(let i = 0; i < joss_stick_name1.length; i++) {
          joss_stick_name1[i].style.display = 'flex';
          joss_stick_name1[i].querySelector('input').required = true;
        }
    
        for(let i = 0; i < joss_stick_name1.length; i++) {
          joss_stick_name2[i].style.display = 'flex';
          joss_stick_name2[i].querySelector('input').required = true;
        }
    
        for(let i = 0; i < joss_stick_address.length; i++) {
          joss_stick_address[i].style.display = 'flex';
          let inputs = joss_stick_address[i].querySelectorAll('.required');
          for(let a = 0; a < inputs.length; a++) {
            inputs[a].required = true;
          }
        }
    
        for(let i = 0; i < joss_stick_phone.length; i++) {
          joss_stick_phone[i].style.display = 'flex';
          joss_stick_phone[i].querySelector('input').required = true;
        }

        for(let i = 0; i < joss_stick_receive_address.length; i++) {
          joss_stick_receive_address[i].style.display = 'none';
          let addresses = joss_stick_receive_address[i].querySelectorAll('input');

          for(let a = 0; a < addresses.length; a++) {
            addresses[a].checked = false;
          }
        }
      }
      else {
        for(let i = 0; i < joss_stick_name1.length; i++) {
          joss_stick_name1[i].style.display = 'none';
          joss_stick_name1[i].querySelector('input').required = false;
          joss_stick_name1[i].querySelector('input').value = '';
        }
    
        for(let i = 0; i < joss_stick_name1.length; i++) {
          joss_stick_name2[i].style.display = 'none';
          joss_stick_name2[i].querySelector('input').required = false;
          joss_stick_name2[i].querySelector('input').value = '';
        }
    
        for(let i = 0; i < joss_stick_address.length; i++) {
          joss_stick_address[i].style.display = 'none';
          let inputs = joss_stick_address[i].querySelectorAll('.required');
          for(let a = 0; a < inputs.length; a++) {
            inputs[a].required = false;
            inputs[a].value = '';
          }
        }
    
        for(let i = 0; i < joss_stick_phone.length; i++) {
          joss_stick_phone[i].style.display = 'none';
          joss_stick_phone[i].querySelector('input').required = false;
          joss_stick_phone[i].querySelector('input').value = '';
        }

        for(let i = 0; i < joss_stick_receive_address.length; i++) {
          joss_stick_receive_address[i].style.display = 'none';
          let addresses = joss_stick_receive_address[i].querySelectorAll('input');

          for(let a = 0; a < addresses.length; a++) {
            addresses[a].checked = false;
          }
        }
      }
    });
  } catch (error) {
    //console.log(error);
  }
}

export default jossStick